import { ChevronDown, ChevronUp } from 'lucide-react';

const CollapsibleSection = ({
  title,
  sectionKey,
  children,
  icon,
  isExpanded,
  onToggle,
}: {
  title: string;
  sectionKey: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  isExpanded: boolean;
  onToggle: () => void;
}) => {
  return (
    <div className="mb-6 bg-[#1a1a1a] rounded-lg border border-gray-700 overflow-hidden transition-all">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 hover:bg-[#252525] transition-colors"
      >
        <div className="flex items-center gap-3">
          {icon && <span className="text-red-500">{icon}</span>}
          <h3 className="text-lg font-semibold text-white">{title}</h3>
        </div>
        {isExpanded ? <ChevronUp className="text-gray-400" size={20} /> : <ChevronDown className="text-gray-400" size={20} />}
      </button>
      {isExpanded && <div className="p-4 pt-0 space-y-4 border-t border-gray-700">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
